// Misc
import React, { Children, Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import scrollIntoView from 'scroll-into-view';
import size from 'lodash/size';

// Atoms
import EventListener from 'react-event-listener';
import Container from 'atoms/Container';
import Button from 'material-ui/Button';
import Typography from 'atoms/Typography';

// Components
import { AppProgressActivator } from 'components/AppProgress';

// Styles
import styles from './styles';

@withStyles(styles)
export default class FormContainer extends Component {
  static propTypes = {
    children: PropTypes.any,
    classes: PropTypes.object.isRequired,
    submitButtonText: PropTypes.any,
    onSubmit: PropTypes.func,
    validator: PropTypes.object.isRequired,
    observedRequest: PropTypes.object.isRequired,
  };

  static defaultProps = {
    submitButtonText: 'Submit',
    onSubmit: () => {},
  };

  state = {
    activeSectionIndex: 0
  };

  componentDidMount() {
    const { activeSectionIndex } = this.state;
    this.screenCenter = this.findScreenCenter();
    this.activateSection(activeSectionIndex, { time: 0 });
  }

  componentWillReceiveProps() {
    this.calcActiveSectionIndex();
  }

  topOffset = 0;

  sectionNodes = [];

  findScreenCenter() {
    return (window.innerHeight / 2) + this.offsetMeter.offsetTop;
  }

  calcActiveSectionIndex = () => {
    let activeSectionIndex = 0;

    while (
      activeSectionIndex + 1 < this.sectionNodes.length &&
      this.sectionNodes[activeSectionIndex + 1].getBoundingClientRect().top < this.screenCenter
    ) {
      activeSectionIndex += 1;
    }

    if (activeSectionIndex !== this.state.activeSectionIndex) {
      this.setState({ activeSectionIndex });
    }
  };

  activateSection(index, params = {}) {
    if (this.sectionNodes[index]) {
      scrollIntoView(this.sectionNodes[index], {
        align: { topOffset: this.offsetMeter.offsetTop },
        ...params
      });
    }
  }

  activateNextSection() {
    const nextIndex = this.state.activeSectionIndex + 1;
    this.activateSection(nextIndex);
  }

  handleScroll = () => {
    this.calcActiveSectionIndex();
  };

  handleResize = () => {
    this.screenCenter = this.findScreenCenter();
    this.calcActiveSectionIndex();
  };

  handleReviewClick = (sectionWithErrorIndex) => {
    this.activateSection(sectionWithErrorIndex);
  };

  sectionNodeRef(node, index) {
    this.sectionNodes[index] = node;
  }

  offsetMeterRef = (node) => {
    this.offsetMeter = node;
  };

  renderSubmitButton(sectionWithErrorIndex) {
    const { submitButtonText, classes, validator, observedRequest } = this.props;
    const errorsCount = size(validator.getAllErrors());
    return (
      <div>
        { validator.isInvalid &&
          <Typography
            color="error"
            type="body2"
            className={classes.error}
          >
            You have
            {' '}
            { errorsCount === 1 ? 'a validation error' : `${errorsCount} validation errors` }
            {' '}
          </Typography>
        }

        { observedRequest.isFailure() &&
          <Typography
            color="error"
            type="body2"
            className={classes.error}
          >
            { observedRequest.getErrorMessage() }
          </Typography>
        }

        { validator.isInvalid && sectionWithErrorIndex !== undefined ?
          <Button
            raised
            color="accent"
            onClick={() => this.handleReviewClick(sectionWithErrorIndex)}
          >
            Review
          </Button> :
          <Button
            raised
            type="submit"
            color="accent"
            disabled={observedRequest.isPending()}
          >
            { submitButtonText }
          </Button>
        }
      </div>
    );
  }

  renderChildren() {
    const { children, onSubmit, classes } = this.props;
    const { activeSectionIndex } = this.state;
    let sectionWithErrorIndex;

    return Children.map(children, (child, index) => {
      const isLast = index === children.length - 1;
      if (sectionWithErrorIndex === undefined && child.props.hasValidationError) {
        sectionWithErrorIndex = index;
      }

      const sectionClone = cloneElement(child, {
        index,
        disabled: index !== activeSectionIndex,
        buttons: isLast ? this.renderSubmitButton(sectionWithErrorIndex) : undefined,
        nodeRef: node => this.sectionNodeRef(node, index),
        onOverlayClick: () => this.activateSection(index),
        onSkip: () => {
          this.activateNextSection();
          if ('onSkip' in child.props) {
            child.props.onSkip();
          }
        },
        onSubmit: () => {
          this.activateNextSection();
          if ('onSubmit' in child.props) {
            child.props.onSubmit();
          }
          if (isLast) {
            onSubmit();
          }
        }
      });

      return (
        <div>
          { sectionClone }
          { !isLast &&
            <div className={classes.spacer} />
          }
        </div>
      );
    });
  }

  render() {
    const { classes, observedRequest } = this.props;
    return (
      <div>
        <div ref={this.offsetMeterRef} className={classes.offsetMeter} />
        <div className={classes.root}>
          { observedRequest.isPending() &&
            <AppProgressActivator />
          }
          <EventListener
            target="window"
            onScroll={this.handleScroll}
            onResize={this.handleResize}
          />
          <Container className={classes.container}>
            { this.renderChildren() }
          </Container>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ScrollForm/Container/index.js